/**
 * Created with IntelliJ IDEA.
 * User: danielg
 * Date: 12/18/13
 * Time: 3:57 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    var agentLEManager = require('web-agent-utils/agentLEManager');

    lpTag.PrivilegeChecker = function () {
        var privilegeChecker = {applicationType: "PrivilegeChecker"};
        privilegeChecker.privilegeIds = {
            participate: 13,
            viewAllChats: 10,
            viewSkillChats: 9
        };

        var LeMethod = function (privilegeId) {
            var hasPrivilege = agentLEManager.hasLEPrivilege(privilegeId);
            if (typeof hasPrivilege === "undefined" || hasPrivilege == null) {
                return true;
            }
            return hasPrivilege;
        };

        privilegeChecker.getPrivileges = function (userMethod) {
            var chosenMethod = userMethod || LeMethod;
            var privileges = {};

            for (var name in privilegeChecker.privilegeIds) {
                privileges[name] = chosenMethod(privilegeChecker.privilegeIds[name]);
            }
            return privileges;
        };

        return privilegeChecker;
    };

    return lpTag.PrivilegeChecker;

});
